const a_Product_Data = [
  ['Classic Denim Jeans', '49.99', '1-a', 'Levi','new'],
  ['Performance Running Shoes', '79.99', '1-a', 'Nike',''],
  ['Graphic Print T-Shirt', '29.99', '1-a', 'Adidas','deal'],
  ['Stylish Denim Trucker Jacket', '59.99', '1-a', 'Wrangler',''],
  ['Waterproof Hiking Boots', '89.99', '1-a', 'Columbia','sold'],
  ['Slim Fit Denim Jeans', '59.99', '1-a', 'Levi','new'],
  ['Dri-FIT Training Shorts', '34.99', '1-a', 'Nike',''],
  ['Lightweight Track Jacket', '44.99', '1-a', 'Adidas',''],
  ['Flannel Button-Up Shirt', '39.99', '1-a', 'Wrangler',''],
  ['Fleece Pullover Hoodie', '49.99', '1-a', 'Columbia','new'],


  ['Air Max 90', '120.00', '2-a', 'Nike','deal'],
  ['Superstar Sneakers', '100.00', '2-a', 'Adidas',''],
  ['SK8-Hi High Top Sneakers', '75.00', '2-a', 'Vans',''],
  ['Jack Purcell Low Top', '65.00', '2-a', 'Converse',''],
  ['Clyde Court Basketball Shoes', '120.00', '2-a', 'Puma','new'],
  ['Air Zoom Pegasus 38', '120.00', '2-a', 'Nike','sold'],
  ['Cloudfoam Ultimate Sneakers', '90.00', '2-a', 'Adidas',''],
  ['Fresh Foam 1080v11', '150.00', '2-a', 'New Balance',''],
  ['HOVR Sonic 4', '110.00', '2-a', 'Under Armour',''],
  ['Nano X1 Training Shoes', '130.00', '2-a', 'Reebok','new'],

];
export default a_Product_Data;